// from: https://www.npmjs.com/package/vue-textarea-autosize
export default {
	name: 'TextareaAutosize',
	template: `
		<textarea
		:style="computedStyles"
		v-model="val"
		@focus="onfocus"
		@blur="onblur"
		></textarea>
	`,
	props: {
		value: {
			type: [String, Number],
			default: ''
		},
		autosize: {
			type: Boolean,
			default: true
		},
		minHeight: {
			type: [Number],
			default: null
		},
		maxHeight: {
			type: [Number],
			default: null
		},
		/*
		 * Force !important for style properties
		 */
		important: {
			type: [Boolean, Array],
			default: false
		}
	},
	data () {
		return {
			// data property for v-model binding with real textarea tag
			val: null,
			// works when content height becomes more then value of the maxHeight property
			maxHeightScroll: false,
			height: 'auto',
			loadHandler: null
		}
	},
	computed: {
		computedStyles () {
			if (!this.autosize) return {}
			return {
				resize: !this.isResizeImportant ? 'none' : 'none !important',
				height: this.height,
				overflow: this.maxHeightScroll ? 'auto' : (!this.isOverflowImportant ? 'hidden' : 'hidden !important')
			}
		},
		isResizeImportant () {
			const imp = this.important
			return imp === true || (Array.isArray(imp) && imp.includes('resize'))
		},
		isOverflowImportant () {
			const imp = this.important
			return imp === true || (Array.isArray(imp) && imp.includes('overflow'))
		},
		isHeightImportant () {
			const imp = this.important
			return imp === true || (Array.isArray(imp) && imp.includes('height'))
		}
	},
	watch: {
		value (val) {
			this.val = val
		},
		val (val) {
			this.$nextTick(this.resize)
			this.$emit('input', val)
		},
		minHeight () {
			this.$nextTick(this.resize)
		},
		maxHeight () {
			this.$nextTick(this.resize)
		},
		autosize (val) {
			if (val) this.resize()
		}
	},
	methods: {
		focus () {
			this.$el.focus()
		},
		blur () {
			this.$el.blur()
		},
		onfocus () {
			this.resize()
			this.$emit('focus')
		},
		onblur () {
			this.$emit('blur')
		},
		resize () {
			const important = this.isHeightImportant ? 'important' : ''
			this.height = `1px${important ? ' !important' : ''}`
			this.$nextTick(() => {
				let contentHeight = this.$el.scrollHeight + 1

				if (this.minHeight) {
					contentHeight = contentHeight < this.minHeight ? this.minHeight : contentHeight
				}

				if (this.maxHeight) {
					if (contentHeight > this.maxHeight) {
						contentHeight = this.maxHeight
						this.maxHeightScroll = true
					} else {
						this.maxHeightScroll = false
					}
				}

				const heightVal = contentHeight + 'px'
				this.height = `${heightVal}${important ? ' !important' : ''}`
			})

			return this
		}
	},
	created () {
		this.val = this.value
	},
	mounted () {
		// 力技で高さがちゃんと初期化できない問題に対処する
		const cb = () => this.resize()
		this.$nextTick(cb)
		setTimeout(cb, 100)
		setTimeout(cb, 200)
		setTimeout(cb, 400)
	}
}
